module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1AGxSN7/tc-custom/9781614238065.jpg?1702530539692",
      "alt": "This image is the cover for the book Growing Up in the Piedmont Triad"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Growing Up in the Piedmont Triad\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("North Carolina's Piedmont Triad was a magical place to grow up in the '40s and '50s. Time ticked slowly with The Lone Ranger on black-and-white TV sets, newspaper cartoons like Roy Rogers and nine-cent Saturday morning kiddie movies. Teens joined the Latin Club, danced at the city swimming pool's upstairs pavilion and swooned over Elvis Presley at the YMCA. Parents hosted bridge parties, followed Sam Sneed at the Greensboro Open and listened to Ella Fitzgerald at Club Kilby. Travel back with local author Alice Sink to the halcyon days of country fairs, stock car racing at Bowman Gray Stadium and Betty Crocker. Featuring nostalgic Triad recipes and an \"Older than Dirt\" quiz, this compendium of memories will make anyone of a certain age with roots around these parts feel like a kid in a candy store.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Alice E. Sink\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Alice E. Sink was an Associate Professor of English for thirty years at High Point University in North Carolina. She is the published author of numerous books, articles, and essays; she earned her MFA in Creative Writing from UNC Greensboro. In 2007, she was awarded a grant to promote her writing from the Central Piedmont Regional Artists Hub.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0